import { Box, BoxProps } from '@chakra-ui/react';

import { Image } from '$components/chakra/image';

interface AndroidMockProps extends Omit<BoxProps, 'children'> {
  src: string;
  alt: string;
  compact?: boolean;
}

export function AndroidMock({
  src,
  alt,
  compact = false,
  ...props
}: AndroidMockProps) {
  const radius = compact ? '18px' : '34px';
  const innerRadius = compact ? '8px' : '20px';
  const bezelTop = compact ? '18px' : '30px';
  const bezelBottom = compact ? '16px' : '26px';
  const bezelSide = compact ? '6px' : '12px';
  const cameraSize = compact ? '4px' : '7px';
  const cameraTop = compact ? '7px' : '12px';
  const buttonRight = '-2px';
  const buttonHeight = compact ? '20px' : '40px';

  return (
    <Box
      pos="relative"
      w="full"
      h="full"
      bg="#1A1714"
      borderRadius={radius}
      pt={bezelTop}
      pb={bezelBottom}
      pl={bezelSide}
      pr={bezelSide}
      boxShadow={
        compact
          ? '0 4px 12px -6px rgba(20, 17, 14, 0.25)'
          : '0 18px 50px -16px rgba(20, 17, 14, 0.35)'
      }
      sx={{
        outline: '1px solid rgba(255, 255, 255, 0.04)',
        outlineOffset: '-2px',
      }}
      {...props}
    >
      {/* Camera punch-hole */}
      <Box
        pos="absolute"
        top={cameraTop}
        left="50%"
        transform="translateX(-50%)"
        w={cameraSize}
        h={cameraSize}
        borderRadius="full"
        bg="#000"
        boxShadow="inset 0 0 0 1px rgba(255,255,255,0.08)"
      />

      {/* Side power button (subtle nub on right edge) */}
      <Box
        pos="absolute"
        right={buttonRight}
        top="34%"
        w="2px"
        h={buttonHeight}
        borderRightRadius="2px"
        bg="rgba(255,255,255,0.08)"
      />

      {/* Screen */}
      <Box
        pos="relative"
        w="full"
        h="full"
        overflow="hidden"
        borderRadius={innerRadius}
        bg="#000"
      >
        <Image src={src} alt={alt} objectFit="contain" w="100%" h="100%" />
      </Box>

      {/* Bottom navigation indicator pill */}
      <Box
        pos="absolute"
        bottom={compact ? '5px' : '10px'}
        left="50%"
        transform="translateX(-50%)"
        w={compact ? '32px' : '64px'}
        h={compact ? '2px' : '3px'}
        borderRadius="full"
        bg="rgba(255,255,255,0.22)"
      />
    </Box>
  );
}
